import Settings from "@/views/settings/SettingsTab";
import { createRouteWithPermissionCheck } from "@/router/utils";
import Profile from "@/views/settings/Profile";
import Notifications from "@/views/settings/Notifications";
import OrganisationTab from "@/views/settings/Organisation/OrganisationTab";
import OrganisationUsers from "@/views/settings/Users/OrganisationUsers";
import OrganisationUnitsList from "@/views/settings/Organisation/Units/OrganisationUnitsList";
import PublishingSchedules from "@/views/settings/components/publishing-schedule-templates/PublishingSchedules";
import Roles from "@/views/settings/components/role-templates/Roles";
import MessageTemplates from "@/views/settings/components/message-templates/MessageTemplates";
import InterviewFormatTemplates from "@/views/settings/components/interview-format-templates/InterviewFormatTemplates";
import ApplicationQuestionTemplates from "@/views/settings/components/application-question-templates/ApplicationQuestionTemplates";
import { redirectWithPermissionCheck } from "@/router/index";
import { MAIN_NAVIGATION_ITEMS } from "@/router/constants";
import OrganisationDetailsTab from "@/views/settings/Organisation/Units/details/OrganisationUnitDetailsTab";
import OrganisationDetails from "@/views/settings/Organisation/Units/details/OrganisationUnitDetails";
import ScopedUsers from "@/views/settings/Organisation/Units/details/ScopedUsers";
import ApprovalChainTemplates from "@/views/settings/components/approval-chain-templates/ApprovalChainTemplates";
import MicrositeList from "@/views/settings/components/microsites/MicrositeList";
import MicrositeDetails from "@/views/settings/components/microsites/components/MicrositeDetails";

const { SETTINGS } = MAIN_NAVIGATION_ITEMS;

export const settingsRouter = [
  {
    path: "/settings",
    name: SETTINGS,
    component: Settings,
    beforeEnter: (to, from, next) => {
      return redirectWithPermissionCheck(next, SETTINGS);
    },
    children: [
      createRouteWithPermissionCheck({
        path: "profile",
        component: Profile
      }),
      createRouteWithPermissionCheck({
        permission: "settings.edit-notifications",
        path: "notifications",
        component: Notifications
      }),
      createRouteWithPermissionCheck({
        path: "users",
        component: OrganisationUsers,
        permission: "settings.view-org-users"
      }),
      createRouteWithPermissionCheck({
        path: "roles",
        component: Roles,
        permission: "settings.edit-booking-templates"
      }),
      createRouteWithPermissionCheck({
        path: "publishing-schedules",
        component: PublishingSchedules,
        permission: "settings.publishing-schedules.view"
      }),
      createRouteWithPermissionCheck({
        path: "messages",
        component: MessageTemplates
      }),
      createRouteWithPermissionCheck({
        path: "interviews",
        component: InterviewFormatTemplates
      }),
      createRouteWithPermissionCheck({
        path: "application-questions",
        component: ApplicationQuestionTemplates
      }),
      createRouteWithPermissionCheck({
        path: "organisation",
        component: OrganisationTab,
        permission: "settings.edit-organisation",
        children: [
          createRouteWithPermissionCheck({
            path: "active",
            component: OrganisationUnitsList,
            permission: "settings.edit-organisation-unit",
            props: { isArchive: false }
          }),
          createRouteWithPermissionCheck({
            path: "archived",
            component: OrganisationUnitsList,
            permission: "settings.edit-organisation-unit",
            props: { isArchive: true }
          })
        ]
      }),
      createRouteWithPermissionCheck({
        path: "approval-chains",
        component: ApprovalChainTemplates
      }),
      createRouteWithPermissionCheck({
        path: "microsites",
        component: MicrositeList
      })
    ]
  },
  {
    path: "/settings/organisation/:id",
    component: OrganisationDetailsTab,
    redirect: "/settings/organisation/:id/units",
    beforeEnter: (to, from, next) => {
      return redirectWithPermissionCheck(
        next,
        "settings.edit-organisation-unit"
      );
    },
    children: [
      createRouteWithPermissionCheck({
        path: "units",
        component: OrganisationDetails,
        permission: "settings.edit-organisation-unit"
      }),
      createRouteWithPermissionCheck({
        path: "users",
        component: ScopedUsers,
        permission: "settings.edit-organisation-unit"
      })
    ]
  },
  {
    path: "/settings/microsites/:id",
    name: "micrositeDetails",
    component: MicrositeDetails,
    beforeEnter: (to, from, next) => {
      return redirectWithPermissionCheck(next, "settings.microsites.view");
    }
  }
];
